class RecentlyViewed {
  constructor({ container, renderItem = null, limit = 3, renderItemsContainer = null }) {
    this.items = this.storedItems;
    this.limit = limit;
    this.recordCurrentPage();
    this.containerSelector = container;
    this.renderItem = renderItem ?? this.renderItem;
    this.renderItemsContainer = renderItemsContainer ?? this.renderItemsContainer;
    this.render();

  }

  recordCurrentPage() {
    const { pathname } = window.location;
    const [handle, template] = pathname.split("/").reverse();

    if (template !== "products") return;

    this.add(handle);
  }


  async render() {
    const products = await this.fetchRecentProducts();

    
    this.containers.forEach((container) => {
      const itemsHtml = products.map((item) => this.renderItem(item)).join("")
      container.innerHTML = this.renderItemsContainer(itemsHtml);
    });
  }

  renderItemsContainer(itemsHtml) {
    return itemsHtml;
  }

  renderItem(item) {
    // console.log('Render recently viewed:', item);
    
   return `
     <div class="recently-viewed-item">
      <a href="${item.url}">
        <img src="${item.featured_image}" alt="${item.title}" />
        <span>${item.title}</span>
      </a>
     </div>
  `
 }

  add(item) {
    // we want to add the item to the beginning of the array
    const newItems = [item, ...this.items];
    
    console.log('Record item:', this.items, item, newItems);
    
    this.items = [...new Set(newItems)];

    this.saveItems();
  }

  remove(item) {
    this.items = this.items.filter((i) => i !== item);
    this.saveItems();
  }

  saveItems() {
    localStorage.setItem("recentlyViewed", JSON.stringify(this.items));
  }

  async fetchRecentProducts() {
    const products = await Promise.allSettled(
      this.eligibleHandles.map(this.fetchProductByHandle)
    );

    return products.reduce(
      (products, { status, value }) =>
        status === "fulfilled" ? products.concat(value) : products,
      []
    );
  }

  fetchProductByHandle(handle) {
    return fetch(`/products/${handle}.js`).then((res) => res.json());
  }

  get eligibleHandles() {
    const items = this.storedItems;

    return items.filter((handle) => handle !== this.urlHandle).slice(0, this.limit);
  }

  get urlTemplate() {
    const { pathname } = window.location;
    const [, template] = pathname.split("/").reverse();

    return template;
  }

  get urlHandle() {
    const { pathname } = window.location;
    const [handle, template] = pathname.split("/").reverse();

    return handle;
  }

  get storedItems() {
    const items = localStorage.getItem("recentlyViewed");
    console.log('get storedItems:', items);
    
    return items ? JSON.parse(items) : [];
  }

  get containers() {
    return [...document.querySelectorAll(this.containerSelector)];
  }
}

window.RecentlyViewed = RecentlyViewed;

window.recentlyViewed = new RecentlyViewed({
  container: ".recently-viewed",
});